/**
 * 基于原生 HTML5 拖拽的列表排序，不引入额外依赖。
 *
 * 用法：混入 dragSortMixin，列表项上绑定
 *   draggable="true"
 *   @dragstart="onDragStart(index, $event, group)" @dragover.prevent="onDragOver(index, group)"
 *   @drop.prevent="onDrop(list, onChange)" @dragend="onDragEnd"
 * group 可选，用于多个列表并排时只允许在同一组内拖动。
 * onChange(newList) 在顺序真正改变时调用。
 */
export function createDragState() {
    return { from: -1, over: -1, group: null }
}

export const dragSortMixin = {
    data() {
        return { drag: createDragState() }
    },
    methods: {
        onDragStart(index, event, group = null) {
            this.drag = { from: index, over: -1, group }
            if (event && event.dataTransfer) {
                event.dataTransfer.effectAllowed = 'move'
                // Firefox 需要设置数据才会触发拖拽
                event.dataTransfer.setData('text/plain', String(index))
            }
        },
        onDragOver(index, group = null) {
            if (this.drag.from > -1 && this.drag.group === group) this.drag.over = index
        },
        onDrop(list, onChange) {
            const { from, over } = this.drag
            this.onDragEnd()
            if (from < 0 || over < 0 || from === over) return
            const next = [...list]
            const [moved] = next.splice(from, 1)
            next.splice(over, 0, moved)
            onChange(next)
        },
        onDragEnd() {
            this.drag = createDragState()
        },
        dragClass(index, group = null) {
            const same = this.drag.group === group
            return {
                'is-dragging': same && this.drag.from === index,
                'is-drag-over': same && this.drag.over === index && this.drag.from !== index,
            }
        },
    },
}
